const NBPTermsTemplate = {
    metadata: {
        slotProps: {
            root: {
                sx: {
                    '.MuiDialogTitle-root': {
                        fontFamily: 'Poppins',
                        fontWeight: '400 !important',
                        fontSize: '1.938rem'
                    }
                }
            },
            title: {
                heading: {
                    sx: {
                        size: 'title2',
                        color: '#12202C'
                    }
                },
                icon: {
                    sx: {
                        color: '#00476A'
                    }
                }
            },
            paragraph: {
                variant: 'paragraph',
                sx: {
                    color: '#12202C',
                    textAlign: 'left',
                    marginTop: '4',
                    fontFamily: 'Poppins',
                    fontSize: '0.625rem',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    whiteSpace: 'pre-wrap'
                }
            },
            headerText: {
                variant: 'caption-bold',
                sx: {
                    color: '#12202C',
                    textAlign: 'left',
                    marginBottom: '1rem'
                }
            },
            buttonCTA1: {
                variant: 'contained',
                size: 'medium',
                sx: {
                    display: 'flex',
                    flex: '1 0 0',
                    maxWidth: { xs: '100%', lg: '15.75rem' },
                    cursor: 'pointer',
                    textTransform: 'capitalize',
                    width: { xs: '100%', lg: 'auto' }
                }
            },
            stack: {
                body: {
                    sx: {
                        space: '10',
                        height: '100%'
                    }
                }
            }
        },
        popupTemplate: ''
    },
    header: {
        content: 'Terms and Conditions',
        type: 'text'
    },
    body: [
        {
            type: 'headerText',
            content: 'Terms and Conditions'
        },
        {
            type: 'paragraph',
            content: 'slTerms'
        }
    ],

    callToActions: [
        {
            type: 'cta-deep-link',
            content: '{{buttonCTA1}}',
            metadata: {
                deeplink: 'offer',
                values: {
                    buttonCTA1: 'Go Back'
                }
            },
            event: {
                action: 'GoBackToOffer'
            }
        }
    ]
};

export default NBPTermsTemplate;
